import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { titleMap } from "./configData";



const DynamicTitle = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = `Chốt BĐS | ${titleMap[location.pathname]}` || "Không Xác Định";
  }, [location.pathname]);

  return null;
};

export default DynamicTitle;
